import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';

export default function FeatureErrorBanner({
  onClose,
}: {
  onClose: () => void;
}) {
  const { t } = useTranslation('app');

  return (
    <div className="layout-boundary pt-3x md:pt-4x">
      <div className="layout-boundary__inner px-2x md:px-0">
        <div className="bg-[#FFF1F1] flex w-full rounded-[8px] border-s-[4px] border-[#E50C0C] items-start gap-1.5x px-2x py-1.5x">
          <button
            type="button"
            aria-label="close-feature-error"
            onClick={onClose}
            className="element-center h-2.5x w-2.5x shrink-0 rounded-full bg-red_dark text-white"
          >
            <Icon name="close" size="20px" />
          </button>
          <div className="flex flex-col gap-[2px]">
            <p className="text-link text-black">{t('featureErrorTitle')}</p>
            <p className="text-caption-2 text-gray__dark_2">
              {t('featureErrorDescription')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
